import { useAuth } from "@/contexts/AuthContext";
import { userRoles } from "@/lib/constants";
import { Navigate, useLocation } from "react-router-dom";

export default function SuperuserRoute({ children }) {
  const { user, ready } = useAuth();
  const loc = useLocation();
  if (!ready) return <div className="p-10 label-cap">Loading…</div>;
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (!userRoles(user).includes("superuser")) return <Navigate to="/" replace />;
  return children;
}
